import { ChangeEvent } from "react"
import { StyledInput, StyledLabel, StyledTextFieldFormItem } from "./styled"
import { stripNonDigits } from "utils"

interface IProps {
  label: string
  value: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

const BarcodeInput = (props: IProps) => {
  const { label, value, onChange, placeholder, disabled = false } = props

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(stripNonDigits(e.target.value))
  }

  return (
    <StyledTextFieldFormItem
      style={
        {
          "--input-padding-right": "var(--input-padding)",
        } as React.CSSProperties
      }
    >
      <StyledLabel>{label}</StyledLabel>

      <StyledInput
        inputMode="numeric"
        $disabled={disabled}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        autoComplete="off"
        style={{
          paddingRight: "var(--input-padding-right)",
        }}
      />
    </StyledTextFieldFormItem>
  )
}

export default BarcodeInput
